require.ensure(["./acircular2"], function(require) {
	require("./acircular2");
})


/*****************
 ** WEBPACK FOOTER
 ** ./chunks/runtime/acircular.js
 ** module id = 1
 ** module chunks = 1 3
 **/